export function doSearch(stores, searchTerm, callback) {
  stores.map(s => storeSearch(s, searchTerm, callback));
}

async function storeSearch(store, searchTerm, callback) {
  try {
    const response = await fetch(`api/FerretSearch?search=${searchTerm}&key=${store.handlerName}`);
    const data = await response.json();
    store.results = data ? data.results : null;
    store.completed = true;
  } catch (ex) {
    store.completed = true;
    store.results = null;
  }
  
  callback(store);
}

export async function sendMessage(message) {
  try {
    const response = await fetch(`api/FerretMessage`,
      {
        method: 'post',
        headers: {
          "Content-type": "application/json"
        },
        body: JSON.stringify(message)
      });

    const data = await response.text();

    return {
      isOk: true,
      message:data
  }
  } catch (ex) {
    return {
      isOk: false,
      message:'Could not send message.'
    }
  }

}